// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/hebel-aus-polyamid-pa/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteHebelAusPolyamidPaDE: PageEntry = {
  id: "example.produkte-hebel-aus-polyamid-pa",
  locale: "de",
  slug: "produkte/hebel-aus-polyamid-pa",
  seo: {
    title: "Hebel aus Polyamid (PA) | Dietz GmbH",
    description: "Hebel aus Polyamid (PA) mit einem Glasfaseranteil von 30% zur Weiterverarbeitung in Schaltersystemen. Diese Bauteile übertragen Bewegungen in komplexen Baugruppen.",
  },
  type: "post",
  h1: "Hebel aus Polyamid (PA)",
  intro: "Hebel aus Polyamid (PA) mit einem Glasfaseranteil von 30% zur Weiterverarbeitung in Schaltersystemen. Diese Bauteile übertragen Bewegungen in komplexen Baugruppen.",
  blocks: [
    { kind: "image", src: "/images/live/DTZ_Hebel-_Polyamid.jpg", alt: "Hebel aus Polyamid", width: 800, height: 640 }
  ],
};
